import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';
/**
 * defa.models.PickupTime
 * The DEFA PickupTime model.
 * @version 1.2.0
 */
const channelObjects = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;

const api = {
	linkcom: apiHost + '/linkcom/',
	security: '/security/security?attrs='
};

const Security = ControlModel.extend( {
	
	url: function(){
		return api.linkcom + this.get('id') + api.security + this.getAttributes();
	},
	
	defaults: _.extend({},ControlModel.prototype.defaults, {
		alarmMask: null,
		alarmMaskError: null,
		
		securityActivated: null,
		securityActivatedError: null,
		
		speedThreshold   : null,
		speedThresholdError   : null,
	}),
	
	parse: function( response, options ) {
		if(response){
			let newModelAttributes = {};
			if(response.securityActivated){
				this.parseAttribute('securityActivated', response.securityActivated, options, newModelAttributes);
			}
			if(response.speedThreshold){
				this.parseAttribute('speedThreshold', response.speedThreshold, options, newModelAttributes);
			}
			if(response.alarmMask){
				this.parseAttribute('alarmMask', response.alarmMask, options, newModelAttributes);
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channelObjects.request('securitys').add(newModelAttributes, { merge: true });
		}
	
	},
	
	toBackendJSON: function(){
		return {
			alarmMask: this.get('alarmMask'),
			securityActivated: this.get('securityActivated'),
			speedThreshold: this.get('speedThreshold')
		};
	},
	
	getAttributes: function(){
		return 'securityActivated,alarmMask,speedThreshold';
	}
});

export default Security;
